import axios from 'axios'
axios.defaults.baseURL = `${process.env.REACT_APP_API_URL}/api`

const incidences = 'OrderIncidences'

export const getIncidences = (filters) => {
  return axios.post(`/${incidences}/PaginatedAndFiltered`, filters)
}

export const getIncidence = (id) => {
  return axios.get(`/${incidences}/${id}`)
}

export const acceptIncidence = (data) => {
  return axios.put(`/${incidences}`, data)
}
